<template>
  <!-- -->
  <div class="customer-detail">
    <list-page>
      <list-table background-color="#FFF" class="form-content" :show-shadow="false">
        <form-tag label="基本信息"/>
        <form-items :data="dataDetail" :columns="2" ref="formData">
          <form-item label="客户名称" :required="true" error-message="请输入客户名称" name="merchantRemarkName">
            <el-input v-model="dataDetail.merchantRemarkName" placeholder="请输入客户名称"/>
          </form-item>
          <form-item label="联系电话">
            <el-input v-model="dataDetail.merchantRemarkPhone" placeholder="请输入联系电话"/>
          </form-item>
          <form-item label="电子信箱">
            <el-input v-model="dataDetail.merchantRemarkEmail" placeholder="请输入电子信箱"/>
          </form-item>
          <!-- 往来类型：1个人 0公司。客户本体是个人还是公司，与下面的「客户类型」字典是两回事 -->
          <form-item label="往来类型">
            <el-select :disabled="!!dataDetail.id" v-model="dataDetail.contactType" placeholder="请选择往来类型">
              <el-option :value="CONTACT_TYPE.PERSON" label="个人"/>
              <el-option :value="CONTACT_TYPE.COMPANY" label="公司"/>
            </el-select>
          </form-item>
          <form-item label="客户类型">
            <el-select v-model="dataDetail.customerType" placeholder="请选择客户类型" clearable>
              <el-option v-for="d in customerTypeList" :key="d.userCode" :label="d.dictName" :value="d.userCode"/>
            </el-select>
          </form-item>
          <form-item label="所属行业">
            <el-select v-model="dataDetail.industryId" placeholder="请选择所属行业" clearable filterable>
              <el-option v-for="d in industryList" :key="d.userCode" :label="d.dictName" :value="d.userCode"/>
            </el-select>
          </form-item>
          <form-item label="是否云客户">
            <el-select v-model="dataDetail.cloudType" placeholder="请选择" clearable>
              <el-option :value="CLOUD_TYPE.YES" label="是"/>
              <el-option :value="CLOUD_TYPE.NO" label="否"/>
            </el-select>
          </form-item>
          <form-item label="软件类型">
            <el-select v-model="dataDetail.softType" placeholder="请选择软件类型" clearable>
              <el-option v-for="d in softTypeList" :key="d.userCode" :label="d.dictName" :value="d.userCode"/>
            </el-select>
          </form-item>
          <form-item label="客户来源">
            <el-select v-model="dataDetail.sourceDictId" placeholder="请选择客户来源" clearable>
              <el-option v-for="d in sourceList" :key="d.userCode" :label="d.dictName" :value="d.userCode"/>
            </el-select>
          </form-item>
          <form-item label="联系人">
            <el-input v-model="dataDetail.merchantRemarkContact" placeholder="请输入联系人"/>
          </form-item>
          <!-- 企业微信环境才显示；新建客户可直接从企业微信选择客户并回填资料 -->
          <partner-wx-bind ref="wxBind" :partner-id="dataDetail.partnerId" :allow-import="!dataDetail.id"
                           @imported="onWxImported"/>
          <form-item label="累计金额(元)" desc-message="新增订阅/续费时会自动累加，也可手工调整">
            <el-input-number v-model="dataDetail.accumulatedAmount" :min="0" :precision="2" :controls="false" style="width: 100%"/>
          </form-item>
          <form-item label="客户分类">
            <el-tree-select v-model="dataDetail.partnerCategory" :data="customerCategories" default-expand-all check-strictly :render-after-expand="true" placeholder="请选择分类" :props="{children: 'children', label: 'dictName'}" node-key="dictCode"/>
          </form-item>
          <form-item label="地区">
            <administrative v-model="dataDetail.merchantRegion"/>
          </form-item>
          <form-item label="负责人">
            <!-- 多选且可拖拽排序：排在第一位的是主要负责人，其余作为业务人员 -->
            <employee-select-sort v-model="dataDetail.ownerEmployeeIds"/>
          </form-item>
        </form-items>
        <form-items v-if="dataDetail.contactType === 0" :columns="2">
          <form-item label="银行账号">
            <el-input v-model="dataDetail.merchantBankAccount" placeholder="请输入银行账号"/>
          </form-item>
          <form-item label="银行户名">
            <el-input v-model="dataDetail.merchantBankAccountName" placeholder="请输入银行户名"/>
          </form-item>
          <form-item label="开户行">
            <el-input v-model="dataDetail.merchantBankName" placeholder="请输入开户行"/>
          </form-item>
          <form-item label="税号">
            <el-input v-model="dataDetail.merchantTaxNumber" placeholder="请输入税号"/>
          </form-item>
        </form-items>
        <form-items v-if="dataDetail.contactType === 1" :columns="2">
          <form-item label="生日">
            <yq-date-picker v-model="dataDetail.merchantBirthday" placeholder="请选择日期" style="width: 100%"/>
          </form-item>
          <form-item label="性别">
            <el-select v-model="dataDetail.merchantGender" placeholder="请选择性别">
              <el-option :value="1" label="男"/>
              <el-option :value="2" label="女"/>
            </el-select>
          </form-item>
          <form-item label="联系地址" :show-block="true">
            <el-input v-model="dataDetail.merchantAddress" placeholder="请输入联系地址"/>
          </form-item>
          <form-item label="备注信息" :show-block="true">
            <el-input v-model="dataDetail.merchantRemark" :rows="5" type="textarea" placeholder="请输入备注信息"/>
          </form-item>
        </form-items>
        <custom-column page-name="customer" app-name="basedata" v-model="dataDetail" :columns="2"/>
        <!-- 企业联系人 -->
        <form-tag label="联系人" />
        <div class="contact-list">
          <div class="contact-item add-new" @click="addNewContact">
            <yq-icon name="element-ui_plus"/>
          </div>
          <div class="contact-item" v-for="(it, id) in dataDetail.contactList" :key="id">
            <table-button class="close" @click="remove(id)" message="是否确认删除联系人">
              <yq-icon name="element-ui_close" />
            </table-button>

            <form-items :columns="1" label-width="2.8rem" icon-width="10px" :data="it">
              <form-item label="联系人名称" :required="true" error-message="请输入联系人名称" name="merchantRemarkName">
                <el-input v-model="it.merchantRemarkName" placeholder="请输入联系人名称"/>
              </form-item>
              <form-item label="联系人手机" :required="true" error-message="请输入联系人手机" name="merchantRemarkPhone">
                <el-input v-model="it.merchantRemarkPhone" placeholder="请输入联系人手机"/>
              </form-item>
              <form-item label="职位">
                <el-select v-model="it.customerPosition" placeholder="请选择职位" clearable>
                  <el-option v-for="d in positionList" :key="d.userCode" :label="d.dictName" :value="d.userCode"/>
                </el-select>
              </form-item>
              <form-item label="关键联系人" desc-message="关键决策人，联系人概况里单独统计">
                <el-select v-model="it.keyContact" placeholder="请选择" clearable>
                  <el-option :value="KEY_CONTACT.YES" label="是"/>
                  <el-option :value="KEY_CONTACT.NO" label="否"/>
                </el-select>
              </form-item>
              <form-item label="生日">
                <el-date-picker v-model="it.merchantBirthday" placeholder="请选择日期" style="width: 100%"/>
              </form-item>
              <form-item label="性别">
                <el-select v-model="it.merchantGender" placeholder="请选择性别">
                  <el-option :value="1" label="男"/>
                  <el-option :value="2" label="女"/>
                </el-select>
              </form-item>
              <form-item label="地区">
                <administrative v-model="it.merchantRegion"/>
              </form-item>
              <form-item label="联系地址">
                <el-input v-model="it.merchantAddress" placeholder="请输入联系地址"/>
              </form-item>
            </form-items>
          </div>
        </div>
      </list-table>
      <form-page :show-page="false" :show-shadow="false">
        <page-button el-type="primary" type="write" @click="saveData">保存</page-button>
      </form-page>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage";
import PageButton from "@/components/h5/button/PageButton";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import customerApi from "@/api/normal/common/customerApi";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
import commonApi from "@/api/commonApi";
import Administrative from "@/components/h5/data/Administrative.vue";
import EmployeeSelectSort from "@/components/h5/data/EmployeeSelectSort.vue";
import YqDatePicker from "@/components/h5/date/YqDatePicker.vue";
import YqIcon from "@/components/YqIcon.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
import CustomColumn from "@/components/h5/data/CustomColumn.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import PartnerWxBind from "@/components/h5/partner/PartnerWxBind.vue";
import {
  CLOUD_TYPE, CONTACT_TYPE, DICT_CUSTOMER_POSITION, DICT_CUSTOMER_SOFT_TYPE, DICT_CUSTOMER_TYPE, DICT_INDUSTRY_TYPE,
  DICT_PARTNER_ORIGIN, KEY_CONTACT
} from "@/views/h5/crm/crmDictionary";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    TableButton,
    PartnerWxBind,
    CustomColumn,
    YqIcon,
    PageButton, ListPage, ListTable, FormPage, FormItems, FormItem, TreeDictionary, Administrative, EmployeeSelectSort, YqDatePicker, FormTag
  },
  data() {
    return {
      dataDetail: {
        merchantAddress: "",
        partnerCategory: "",
        merchantRemarkName: "",
        merchantRemarkPhone: "",
        merchantRemarkEmail: "",
        dataLevel: "",
        contactType: 1,
        // 负责人id串，逗号分隔，第一位是主要负责人
        ownerEmployeeIds: "",
        merchantRemark: "",
        merchantBankAccount: "",
        merchantBankAccountName: "",
        merchantBankName: "",
        merchantTaxNumber: "",
        merchantBirthday: "",
        merchantGender: "",
        contactList: [],
        // crm 扩展字段（字典值存 userCode）
        customerType: "",
        industryId: "",
        softType: "",
        sourceDictId: "",
        merchantRemarkContact: "",
        // cloudType 是后端 Integer，新建留 null；填 "" 会在保存时绑不上
        cloudType: null,
        accumulatedAmount: null,
      },
      customerCategories: [], // 客户分类
      customerTypeList: [],   // 客户类型字典
      industryList: [],       // 所属行业字典
      softTypeList: [],       // 软件类型字典
      sourceList: [],         // 客户来源字典
      positionList: [],       // 联系人职位字典
      // 常量暴露给模板用
      CLOUD_TYPE, CONTACT_TYPE, KEY_CONTACT,
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.route.query.id) { // 详情
        customerApi.findById(this.route.query.id).then(res => {
          this.dataDetail = res;
        });
      } else { // 新建
        // 新建时默认把当前登录人设为主要负责人：普通角色只看得到与自己相关的数据，
        // 留空会导致刚建完的客户在列表里查不到。异步获取用户信息会覆盖用户已改的表单，所以同步取。
        this.dataDetail.ownerEmployeeIds = Util.getEmployeeId();
      }
      commonApi.queryDictionaryTree("CUSTOMER_CATEGORY").then(list => this.customerCategories = list);
      // 字典值由前端关联渲染，后端只存 userCode
      commonApi.queryUniqueDictionaryList(DICT_CUSTOMER_TYPE).then(list => this.customerTypeList = list || []);
      commonApi.queryUniqueDictionaryList(DICT_INDUSTRY_TYPE).then(list => this.industryList = list || []);
      commonApi.queryUniqueDictionaryList(DICT_CUSTOMER_SOFT_TYPE).then(list => this.softTypeList = list || []);
      commonApi.queryUniqueDictionaryList(DICT_PARTNER_ORIGIN).then(list => this.sourceList = list || []);
      // 联系人的职位字典
      commonApi.queryUniqueDictionaryList(DICT_CUSTOMER_POSITION).then(list => this.positionList = list || []);
    },
    // 添加一个联系人
    addNewContact() {
      this.dataDetail.contactList.push({
        customerCategory: this.dataDetail.customerCategory,
        merchantRegion: this.dataDetail.merchantRegion
      })
    },
    /** 企业微信客户回填（提交时才保存客户） */
    onWxImported(contact) {
      if (!contact) {
        return;
      }
      const isCompany = Number(contact.externalType) === 2;
      if (isCompany) {
        this.dataDetail.merchantRemarkName = contact.corpName || contact.userName || "";
        this.dataDetail.merchantRemarkContact = contact.userName || "";
      } else {
        this.dataDetail.merchantRemarkName = contact.userName || "";
        this.dataDetail.merchantRemarkContact = contact.userName || "";
      }
      if (contact.mobile) {
        this.dataDetail.merchantRemarkPhone = contact.mobile;
      }
      this.dataDetail.contactType = isCompany ? 0 : 1;
    },
    // 删除一个联系人
    remove(idx) {
      if (this.dataDetail.contactList[idx].id) {
        // 数据库保存有记录的数据
        customerApi.delete(this.dataDetail.contactList[idx].id);
      }
      this.dataDetail.contactList.splice(idx, 1);
    },
    saveData() {
      if (!this.checkData()) {
        return;
      }
      const payload = JSON.parse(JSON.stringify(this.dataDetail));
      // el-select 清空可能给出 ""，后端 cloudType 是 Integer、accumulatedAmount 是 BigDecimal，
      // 空串会绑不上导致整个保存失败，这里统一归一成 null
      ["cloudType", "accumulatedAmount"].forEach(k => {
        if (payload[k] === "" || payload[k] === undefined) {
          payload[k] = null;
        }
      });
      const isNew = !payload.id;
      customerApi.saveCustomer(payload).then(res => {
        // 新建时如果从企业微信导入过客户，保存成功后先补关联，再刷新详情
        const bind = isNew && this.$refs.wxBind && res && res.partnerId
            ? this.$refs.wxBind.bindPending(res.partnerId)
            : Promise.resolve();
        return bind.then(() => customerApi.findById(res.id));
      }).then(res => {
        this.dataDetail = res;
      });
    },
    checkData() {
      // 如果是个人客户，手机号不能为空
      if (this.dataDetail.contactType === 1 && !this.dataDetail.merchantRemarkPhone) {
        this.$message.error("个人客户联系电话不能为空")
        return false;
      }
      if (this.$refs.formData.validCheck()) {
        for (let i = 0; i < this.dataDetail.contactList.length; i++) {
          if (!this.dataDetail.contactList[i].merchantRemarkName || !this.dataDetail.contactList[i].merchantRemarkPhone) {
            return false;
          }
        }
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-detail{
  height: 100%;
  .form-content{
    padding: 20px;
  }
}
.contact-list{
  padding: 20px;
  display: flex;
  gap: 12px;
  justify-content: flex-start;
  flex-wrap: wrap;
  .contact-item{
    border: 1px solid var(--yq-border-color);
    //box-shadow: 0 0 5px rgba(0,0,0,0.1);
    width: calc(25% - 9px);
    border-radius: 4px;
    display: inline-block;
    padding: 20px;
    vertical-align: top;
    position: relative;
    box-sizing: border-box;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &.add-new{
      line-height: 320px;
      text-align: center;
      height: 100%;
    }
    .close{
      position: absolute;
      right: 10px;
      top: 10px;
      color: var(--el-color-danger);
      font-size: 18px;
      z-index: 1;
    }
  }
}
</style>